import React from "react";
import cx from "classnames";
import { Box } from "@mui/material";
import {
  StyledAcceptedDocumentDialog,
  StyledAcceptedDocCloseBtn,
  StyledModalCloseIcon
} from "./styled";

export const AcceptedDocumentDialog = ({
  title,
  listOfAcceptedDoc,
  open,
  docImage,
  handleClose,
  type,
  modalTitle
}) => {
  const onClose = (_, reason) => {
    if (reason !== "backdropClick") {
      handleClose();
    }
  };

  const header = modalTitle || title?.toLowerCase();

  return (
    <StyledAcceptedDocumentDialog
      onClose={onClose}
      open={open}
      data-testid="accepted-doc-dialog"
      slotProps={{
        backdrop: {
          "aria-label": "backdrop-modal"
        }
      }}
    >
      <Box>
        <StyledModalCloseIcon onClick={onClose} />
        <div className="docHeaderDetails">
          <h2 className="heading">{title}</h2>
          {/* added passportImg class since passport image is jpg format */}
          <div className={cx("docImage", type === "passport" && "passportImg")}>
            <img src={docImage} alt={title} />
          </div>
        </div>
        <div className="acceptedDocDetails">
          <h2 className="acceptedDocHeader">{`List of accepted documents as ${header}:`}</h2>
          <ul className="acceptedDocList">
            {listOfAcceptedDoc?.map(doc => <li key={doc}>{doc}</li>)}
          </ul>
        </div>
        <StyledAcceptedDocCloseBtn onClick={onClose} data-testid="i-understand-btn">
          I understand
        </StyledAcceptedDocCloseBtn>
      </Box>
    </StyledAcceptedDocumentDialog>
  );
};
